export const QUOTES_WATCHLIST_STORAGE_KEYS = {
  CORE: 'mt6_quotes_watchlist_core',
  /**
   * symbolKey -> digits, so a saved watchlist can be RENDERED before the symbol catalog arrives.
   * The catalog streams in batches and used to gate the whole watchlist, which is why a refresh showed
   * "No symbols in watchlist" for as long as it took every symbol to load.
   */
  DIGITS: 'mt6_quotes_watchlist_digits'
} as const;
